import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPut } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const questionWiseUpdate = createAsyncThunk(
  "questionWiseUpdate",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPut(urls?.questionWiseUpdate, arg);
      return response;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

export const questionWiseUpdateSlice = createSlice({
  name: "questionWiseUpdate",
  initialState: {
    isLoading: false,
    success: false,
    data: false,
    error: null,
  },
  reducers: {
    questionWiseUpdateReset: () => {
      return {
        isLoading: false,
        success: false,
        data: false,
        error: null,
      };
    },
  },
  extraReducers: {
    [questionWiseUpdate.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.data = payload;
      state.error = null;
    },
    [questionWiseUpdate.pending]: (state) => {
      state.isLoading = true;
      state.success = false;
      state.data = false;
    },
    [questionWiseUpdate.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.data = false;
      state.error = payload;
    },
  },
});

export const { questionWiseUpdateReset } = questionWiseUpdateSlice.actions;
